import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrokenLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.81183 10.7669L5.74763 11.8311C4.73823 12.8405 3.10166 12.8405 2.09226 11.8311C1.08285 10.8217 1.08285 9.18514 2.09226 8.17573L3.23061 7.03738L4.22065 6.04733C5.23007 5.03793 6.86662 5.03793 7.87602 6.04733",
		stroke: "currentColor",
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.16844 3.02852L8.15859 2.03836C9.16799 1.02896 10.8046 1.02896 11.814 2.03837C12.8234 3.04777 12.8234 4.68433 11.814 5.69374L9.68534 7.82235C8.67594 8.83175 7.03937 8.83175 6.02997 7.82235M3.57525 3.74122L2.75028 2.91626M10.0165 10.1824L10.8415 11.0073M3.1075 4.71705L1.98059 4.41509M10.4843 9.20656L11.6112 9.50851M4.55118 3.27354L4.24923 2.14662M9.04057 10.6501L9.34253 11.777",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgBrokenLink;
